import * as Icons from 'lucide-react';
import { heroAdvantages } from '../mock';
import { CheckCircle2 } from 'lucide-react';

export default function Advantages() {
  return (
    <section className="relative -mt-12 z-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-3 gap-6">
          {heroAdvantages.map((card, i) => {
            const Icon = Icons[card.icon] || Icons.Sparkles;
            return (
              <div key={i} className="bg-white rounded-lg p-8 shadow-[0_24px_60px_-30px_rgba(10,37,64,0.45)] fx-lift border border-slate-100">
                <div className="w-12 h-12 rounded-md bg-fx-cream border border-fx-gold/30 flex items-center justify-center">
                  <Icon className="w-6 h-6 text-fx-gold" />
                </div>
                <h3 className="font-display text-2xl text-fx-navy font-bold mt-5">{card.title}</h3>
                <ul className="mt-5 space-y-3">
                  {card.points.map((p, idx) => (
                    <li key={idx} className="flex gap-3 text-sm text-slate-700">
                      <CheckCircle2 className="w-4 h-4 text-fx-gold shrink-0 mt-0.5" />
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
